/* eslint-disable no-undef */

import $ from 'jquery';

$('form.login').on('login:success', function (event, data) {
  if (data.constructorUserId) {
    window.localStorage.setItem('cnstrcUserId', data.constructorUserId);

    window.cnstrc = window.cnstrc || {};
    window.cnstrc.userId = data.constructorUserId;
  }
});

$(document).on('click', 'a[href*="logout"]', function () {
  try {
    window.localStorage.removeItem('cnstrcUserId');

    window.cnstrc = window.cnstrc || {};
    window.cnstrc.userId = null;
  } catch (e) {
    window.console.error('Constructor logout cleanup failed', e);
  }
});
